module.exports = __webpack_public_path__ + "static/img/mobile-web-img03@w.7c81494.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lotte-tms/mobile-web-img03@w.png
// module id = CMBW
// module chunks = 0